import apiService from '../utils/apiService';

import {
  GET_PLACE_LIST_START,
  GET_PLACE_LIST,
  GET_PLACE_LIST_ERROR,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR,
  GET_PLACE_LIST_PAGEBALE,
  GET_PLACE_LIST_PAGEBALE_START,
  GET_PLACE_LIST_PAGEBALE_ERROR,
  GET_PLACE_FILTER_LIST,
  GET_PLACE_FILTER_LIST_START,
  GET_PLACE_FILTER_LIST_ERROR,
  UPDATE_PLACE,
  UPDATE_PLACE_START,
  UPDATE_PLACE_ERROR,
  CREATE_PLACE,
  CREATE_PLACE_START,
  CREATE_PLACE_ERROR,
  CLEAR_PLACE_LIST,
} from './types';

import {
  placeFindAllPath,
  placeFindAllPageablePath,
  placeFindAllByAutonomousProvincePath,
  placeFindAllWithoutAutonomousProvincePath,
  placeUpdatePath,
  filterPageablePath,
  placeCreatePath,
} from '../constants/apiEndpoints';
import { createNotification } from '../utils';
import { notificationTypeSuccess } from '../constants/globals';

const clearList = () => {
  return {
    type: CLEAR_PLACE_LIST,
  };
};

const getPlaceListStart = () => {
  return {
    type: GET_PLACE_LIST_START,
  };
};
const getPlaceListSuccessfully = (data) => {
  return {
    type: GET_PLACE_LIST,
    payload: data,
  };
};
const getPlaceListUnsuccessfully = (err) => {
  return {
    type: GET_PLACE_LIST_ERROR,
    payload: err,
  };
};

const updatePlaceStart = () => {
  return {
    type: UPDATE_PLACE_START,
  };
};
const updatePlaceSuccessfully = (data) => {
  return {
    type: UPDATE_PLACE,
    payload: data,
  };
};
const updatePlaceUnsuccessfully = (err) => {
  return {
    type: UPDATE_PLACE_ERROR,
    payload: err,
  };
};

const createPlaceStart = () => {
  return {
    type: CREATE_PLACE_START,
  };
};
const createPlaceSuccessfully = (data) => {
  return {
    type: CREATE_PLACE,
    payload: data,
  };
};
const createPlaceUnsuccessfully = (err) => {
  return {
    type: CREATE_PLACE_ERROR,
    payload: err,
  };
};

const getPlaceListPageableStart = () => {
  return {
    type: GET_PLACE_LIST_PAGEBALE_START,
  };
};
const getPlaceListPageableSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_PLACE_LIST_PAGEBALE,
    payload: [data, pageNumber, totalElements],
  };
};
const getPlaceListPageableUnsuccessfully = (err) => {
  return {
    type: GET_PLACE_LIST_PAGEBALE_ERROR,
    payload: err,
  };
};

const getPlaceFilterListStart = () => {
  return {
    type: GET_PLACE_FILTER_LIST_START,
  };
};
const getPlaceFilterListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_PLACE_FILTER_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getPlaceFilterListUnsuccessfully = (err) => {
  return {
    type: GET_PLACE_FILTER_LIST_ERROR,
    payload: err,
  };
};

const getPlaceListByAutonomousProvinceStart = () => {
  return {
    type: GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START,
  };
};
const getPlaceListByAutonomousProvinceSuccessfully = (data) => {
  return {
    type: GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE,
    payload: data,
  };
};
const getPlaceListByAutonomousProvinceUnsuccessfully = (err) => {
  return {
    type: GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR,
    payload: err,
  };
};

const getPlaceListWithoutAutonomousProvinceStart = () => {
  return {
    type: GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START,
  };
};
const getPlaceListWithoutAutonomousProvinceSuccessfully = (data) => {
  return {
    type: GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE,
    payload: data,
  };
};
const getPlaceListWithoutAutonomousProvinceUnsuccessfully = (err) => {
  return {
    type: GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR,
    payload: err,
  };
};

export const findAllPlace = () => {
  return (dispatch) => {
    dispatch(getPlaceListStart());
    return apiService
      .get(placeFindAllPath())
      .then((response) => {
        dispatch(getPlaceListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getPlaceListUnsuccessfully(err?.response?.data));
      });
  };
};

export const updatePlace = (place, callback, messages) => {
  return (dispatch) => {
    dispatch(updatePlaceStart());
    return apiService
      .post(placeUpdatePath(), place)
      .then((response) => {
        dispatch(updatePlaceSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.place,
          messages.updatePlaceSuccessfully
        );
      })
      .catch((err) => {
        dispatch(updatePlaceUnsuccessfully(err?.response?.data));
      });
  };
};

export const createPlace = (place, callback, messages) => {
  return (dispatch) => {
    dispatch(createPlaceStart());
    return apiService
      .post(placeCreatePath(), place)
      .then((response) => {
        dispatch(createPlaceSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.place,
          messages.addPlaceSuccessfully
        );
      })
      .catch((err) => {
        dispatch(createPlaceUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllPlacePageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getPlaceListPageableStart);
    return apiService
      .get(placeFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getPlaceListPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getPlaceListPageableUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllPlaceByAutonomousProvince = (autonomousProvinceId) => {
  return (dispatch) => {
    dispatch(getPlaceListByAutonomousProvinceStart);
    return apiService
      .get(placeFindAllByAutonomousProvincePath(autonomousProvinceId))
      .then((response) => {
        dispatch(getPlaceListByAutonomousProvinceSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getPlaceListByAutonomousProvinceUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllPlaceWithoutAutonomousProvince = () => {
  return (dispatch) => {
    dispatch(getPlaceListWithoutAutonomousProvinceStart);
    return apiService
      .get(placeFindAllWithoutAutonomousProvincePath())
      .then((response) => {
        dispatch(
          getPlaceListWithoutAutonomousProvinceSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getPlaceListWithoutAutonomousProvinceUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findAllPlaceFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getPlaceFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getPlaceFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getPlaceFilterListUnsuccessfully(err?.response?.data));
      });
  };
};

export const clearPlaceList = () => {
  return (dispatch) => {
    dispatch(clearList());
  };
};
